import { Column, Row } from '~components/table-view';
import FundingSourceBadges from '~support-at-home/components/claims/reconciliations-wizard/FundingSourceBadges';

export const amendmentColumns: Column[] = [
  {
    id: 'meta_budgets',
    header: 'Affected Funding',
    type: 'custom',
    style: { width: '400px' },
    component: FundingSourceBadges,
    componentProps: (row: Row) => ({
      meta_budgets: row?.meta_budgets || [],
      funding_sources: row?.funding_sources || [],
    }),
    classNames: { header: 'cell-align-left', column: 'cell-align-left' },
  },
  {
    id: 'service',
    header: 'Service',
    type: 'text',
    style: { width: '150px' },
    classNames: { header: 'cell-align-left', column: 'cell-align-left' },
  },
  {
    id: 'date',
    header: 'Service Date',
    type: 'date',
    style: { width: '120px' },
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'originalCost',
    header: 'Original Cost',
    type: 'currency',
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
  {
    id: 'newCost',
    header: 'New Cost',
    type: 'currency',
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
  {
    id: 'govPaysChange',
    header: 'Govt Pays Change',
    type: 'currency',
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
  {
    id: 'youPayChange',
    header: 'You Pay Change',
    type: 'currency',
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
];
